<template>
  <div class="content-box-student-files" v-if="show">
    <div class="content bg">
      <img class="img-title" :src="require(`../assets/${targetFolder}/studentFiles/student_files_title.png`)" />
      <div class="specific" v-if="isLoading">
        <img @click="closeDialog" class="close" :src="require(`../assets/${targetFolder}/audiovisual/close.png`)" />
        <div class="left-box bg">
          <img class="big-img" :src="list[featureIndex].params.imgs" />
          <div class="view">
            <swiper ref="role" style="height:100%" :options="options.role"  @slide-change-transition-start="featureSlideChange">
                <swiper-slide
                  v-for="(item,index) in list"
                  :key="index">
                  <div class="role-bg">
                     <img v-if="item === featureIndex" :src="item.params.logo">
                     <img v-else :src="item.params.logo">
                  </div>
                  <div v-if="index !== featureIndex" class="role-mark"></div>
                </swiper-slide>
            </swiper>
            <div class="prev" @click="swiperFeaturePrev">
              <img :src="require(`../assets/${targetFolder}/studentFiles/prev.png`)" />
            </div>
            <div class="next" @click="swiperFeatureNext">
              <img :src="require(`../assets/${targetFolder}/studentFiles/next.png`)" />
            </div>
          </div>
        </div>
        <div class="right-box bg">
          <div class="student-name">{{list[featureIndex].params.name}}</div>
          <div class="student-introduction">
            <span>{{list[featureIndex].params.desc}}</span>
          </div>
          <div class="learning-potential">学习潜力：{{list[featureIndex].params.num}}</div>
          <div class="curriculum"><span>兴趣课程：</span> <img :src="list[featureIndex].params.interest_subjects" /></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getWebSiteContent
} from '@/api'
export default {
  name: 'StudentFiles',
  data () {
    // const self = this
    return {
      show: false,
      markShow: false,
      checked: 1,
      options: {
        role: {
          // 设定初始化时slide的索引
          initialSlide: 0,
          slidesPerView: 'auto',
          slideToClickedSlide: true,
          centeredSlides: true, // 设定为true时，active slide会居中，而不是默认状态下的居左
          loop: true
          // navigation: {
          //   nextEl: '.swiper-button-next',
          //   prevEl: '.swiper-button-prev'
          // }
          // noSwiping: true
          // on: {
          //   slideChange: function () {
          //   // alert('改变了，activeIndex为' + this.activeIndex)
          //     let i = this.activeIndex
          //     if (i === 0) {
          //       i = 8
          //     }
          //     if (i === 9) {
          //       i = 1
          //     }
          //     self.activeRoleIndex = i + ''
          //   }
          // }
        }
      },
      featureIndex: 0,
      list: [],
      isLoading: false
    }
  },
  computed: {
    targetFolder () {
      return this.$store.state.targetFolder
    },
    isDesktop () {
      return this.$store.state.isDesktop
    }
  },
  watch: {

  },
  mounted () {

  },
  created () {
    require(`../styles/${this.targetFolder}/studentfiles.scss`)
  },
  methods: {
    closeDialog () {
      this.show = false
      this.featureIndex = 0
      this.$emit('closeDialog')
    },
    swiperFeaturePrev (swiper) {
      window._hmt.push(['_trackEvent', '游戏', 'click_characters'])
      this.$refs.role.$swiper.slidePrev()
    },
    swiperFeatureNext (swiper) {
      window._hmt.push(['_trackEvent', '游戏', 'click_characters'])
      this.$refs.role.$swiper.slideNext()
    },
    featureSlideChange (swiper) {
      window._hmt.push(['_trackEvent', '游戏', 'click_characters'])
      this.featureIndex = swiper.realIndex
    },
    // 新版官网获取数据
    async getWebSiteContent () {
      try {
        const params = {
          type: 4
        }
        const { data } = await getWebSiteContent(params)
        this.list = data
        this.isLoading = true
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
